module.exports = __webpack_public_path__ + "img/logo-with-text.fea0ca0f.svg";